<template>
  <div class="list-search">
    <div class="search-wrapper">
      <input type="text" ref="search_input" v-model="search" class="search-wrapper__search"
             :placeholder="$t('repitition.search_for') + ' '+ $t('repitition.skole')"/>
    </div>
    <div class="list-search__body">
      <ul>
        <li v-for="option in searchList">
          <a :href="option.url" data-no-turbolink="true" @click="chooseItem(option)">{{ option.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list-with-search',
  props: {
    options: {
      required: true
    }
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    searchList () {
      return this.options.filter((obj) => {
        return obj.name !== null ? obj.name.match(new RegExp(this.search, 'i')) : ''
      })
    }
  },
  methods: {
    chooseItem (obj) {
      this.$emit('choose', obj)
    }
  },
  mounted () {
    this.$nextTick(_ => {
      const searchInput = this.$refs.search_input
      if (searchInput) {
        searchInput.focus()
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// ListWithSearch.vue?78a08a6f